"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultCodeTranslation = {
    0: "No error",
    1: "PENDING",
    65: "CREATED",
    66: "DELETED",
    68: "CHANGED",
    69: "CONTENT",
    70: "BUSY",
    128: "Bad request. Meaning device cannot understand your request.",
    129: "UNAUTHORIZED",
    132: "NOT_FOUND",
    133: "METHOD_NOT_ALLOWED",
    134: "NOT_ACCEPTABLE",
    160: "INTERNAL_SERVER_ERROR",
    161: "This resource has not been implemented yet",
    163: "SERVICE_UNAVAILABLE",
    164: "NVM_ERROR",
    165: "UNABLE_TO_CONNECT_TO_TARGET",
    166: "TARGET_POWER_FAILURE",
    167: "NVM_FUL",
    176: "TARGET_PROTOCOL_ERROR",
    177: "TARGET_PROTOCOL_BUSY",
    178: "TARGET_PROTOCOL_REAL",
    179: "TARGET_PROTOCOL_WRONG_PARAM",
    180: "TARGET_PROTOCOL_FORBIDDEN",
    181: "TARGET_PROTOCOL_DATA",
    182: "TARGET_PROTOCOL_COM",
    183: "TARGET_PROTOCOL_LOST_COM",
    184: "TARGET_PROTOCOL_PARAM",
    185: "TARGET_PROTOCOL_INT",
    186: "TARGET_PROTOCOL_ABORT",
    187: "TARGET_PROTOCOL_NOT_IMPLEMENTED"
};
